import { ArtifactStateBadge } from '@@common';
import { CodeBaseStatesModel } from '../../../api/api';

type ArtifactDeploymentStateProps = {
	layerLabel: string;
	state?: CodeBaseStatesModel;
	selected: boolean;
	onSelect: () => void;
};

const stateColor = (state?: CodeBaseStatesModel) => {
	switch (state) {
		case CodeBaseStatesModel.Changed:
			return 'warning.main';
		case CodeBaseStatesModel.Packaged:
			return 'info.main';
		case CodeBaseStatesModel.Deployed:
			return 'success.main';
		default:
			return 'text.disabled';
	}
};

export default function ArtifactDeploymentState({ layerLabel, state, selected, onSelect }: ArtifactDeploymentStateProps) {
	const label = state ?? 'Unavailable';
	return (
		<ArtifactStateBadge
			label={label}
			color={stateColor(state)}
			tooltip={`${layerLabel}: ${label}. Select deployment target.`}
			selected={selected}
			onClick={onSelect}
			ariaLabel={`Use ${layerLabel} for package and deploy actions`}
		/>
	);
}
